module.exports = __webpack_public_path__ + "media/images/twitter-social-icon-circle-color@2x-1ba570a9d74c8a58089afc590ac9beec.png";